// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "world.fncy",
    name: "Fncy Mobile Wallet",
    homepage: "https://fncy.world",
    image_id: "c1c8d374-dff3-419c-96af-3515d0192100",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/fncy-blockchain-platform/id1613707166",
        android: "https://play.google.com/store/apps/details?id=com.metaverse.world.cube&hl=en_US&pli=1",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "metaCubeWallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map